<div class="">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()"><span
            aria-hidden="true">×</span></button>

</div>
<div class="modal-content">
    <div class="container">
        <mat-card appearance="outlined" class="view-page mat-card mat-focus-indicator p-0">
            <div class="card">
                <div class="card-body">
                    <div class="form-field-full">
                        <div class="col p-0">
                            <h1 class="title">View Discount Details </h1>
                        </div>
                        <div class="col-12 p-0 view-content table-responsive">
                            <table class="mb-0 table  table-bordered">
                                <tbody>
                                    <tr>
                                        <td class="label-view text-left col-3">Discount Name</td>
                                        <td class="col-3">{{data.name | titlecase}}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-view text-left col-3">Discount Type</td>
                                        <td class="col-3">{{data.discount_type}}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-view text-left col-3">Discount Amount</td>
                                        <td class="col-3">{{data.value }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-view text-left col-3">Discount Status</td>
                                        <td class="col-3">{{data.isActive == 1 ? "Active" : "Inactive" }}</td>
                                    </tr>
                                    <tr>
                                        <td class="label-view text-left col-3">Has Amount Limitation </td>
                                        <td class="col-3">{{data.hasAmountLimit == 1 ? "Yes" : "No" }}</td>
                                    </tr>
                                    <tr *ngIf="data.hasAmountLimit==1">
                                        <td class="label-view text-left col-3">Min Amount To be applied </td>
                                        <td class="col-3">{{data.minAmount }}</td>
                                    </tr>
                                    <tr *ngIf="data.hasAmountLimit==1">
                                        <td class="label-view text-left col-3">Max Amount To be applied </td>
                                        <td class="col-3">{{data.maxAmount }}</td>
                                    </tr>

                                    <tr>
                                        <td class="label-view text-left col-3"> Has Quantity Limitation </td>
                                        <td class="col-3">{{data.hasQtyLimit == 1 ? "Yes" : "No" }}</td>
                                    </tr>
                                    <tr *ngIf="data.hasQtyLimit==1">
                                        <td class="label-view text-left col-3">Min Quantity To be applied </td>
                                        <td class="col-3">{{data.startQty }}</td>
                                    </tr>
                                    <tr *ngIf="data.hasQtyLimit==1">
                                        <td class="label-view text-left col-3"> Max Quantity To be applied </td>
                                        <td class="col-3">{{data.endQty }}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


        </mat-card>

    </div>